import { Controller } from 'stimulus'

// XXX: os módulos já estão sendo importado pela aplicação geral
// pela dependência de outros componentes.
// Removida as dependencias e o carregamento global, podemos importar
// diretamente nesse controller.

// import $ from 'jquery'
// require('select2/dist/css/select2')
// require('select2-bootstrap-theme/dist/select2-bootstrap')

import select2 from 'select2'
$.fn.select2.amd.define('select2/i18n/pt-BR',[],require("select2/src/js/select2/i18n/pt-BR"))

export default class extends Controller {

  connect() {
    this.element.controller = this

    this.selectElement = this.element
    this.selectElement.controller = this

    $(this.selectElement).select2(this._getSelect2Options())

    this._updateDataState()

    $(this.selectElement).on('change.select2', (aEvent) => {
      const event = new CustomEvent('selected', { bubbles: true })

      this._updateDataState()

      this.selectElement.dispatchEvent(event)
    })

    this.selectElement.getSelectedValue = () => {
      return this._getSelectedValue()
    }

    this.selectElement.hasSelection = () => {
      return this._hasSelection()
    }

    this.selectElement.setEnabled = (aEnabled) => {
      return this._setEnabled(aEnabled)
    }

    this._fireConnected()
  }

  // Public

  clearSelection() {
    this._clearSelection()
  }

  hasSelection() {
    return this._hasSelection()
  }

  getSelectedValue() {
    return this._getSelectedValue()
  }

  // Privates

  _fireConnected() {
    const event = new CustomEvent('connected', { bubbles: true })
    this.selectElement.dispatchEvent(event)
  }

  _clearSelection() {
    $(this.selectElement).val('-1')
    $(this.selectElement).trigger('change')
  }

  _setEnabled(aEnabled) {
    $(this.selectElement).prop('disabled', !aEnabled)

    const event = new CustomEvent('enable_changed', {
      bubbles: true,
      detail: aEnabled
    })

    this.selectElement.dispatchEvent(event)
  }

  _updateDataState() {
    this.selectElement.setAttribute('data-has-selection', this._hasSelection())
  }

  _getSelectedValue() {
    return $(this.selectElement).val()
  }

  _hasSelection() {
    const selectedValue = $(this.selectElement).val()

    if (Array.isArray(selectedValue)) {
      return selectedValue.length > 0
    } else {
      return selectedValue !== null
    }
  }

  _getSelect2Options() {
    let options = null

    if (this.selectElement.multiple) {
      options = {
        templateResult:  (aState) => { return this._formatResultState(aState) },
        templateSelection: (aState, aSelectionContainer) => { return this._formatSelectionState(aState, aSelectionContainer) }
      }
    } else {
      options = {}
    }

    return { ...this._getSelect2BaseOptions(), ...options }
  }

  _getSelect2BaseOptions() {
    return {
      language: 'pt-BR'
    }
  }

  _formatSelectionState(aState, aSelectionContainer) {
    const option = $(aState.element),
          bgColor = this._getBgColor(option),
          fgColor = this._getFgColor(option),
          container = aSelectionContainer[0]

    if (! bgColor) {
      return aState.text
    }

    container.style.background = bgColor
    container.style.borderColor = bgColor

    if (fgColor) {
      container.style.color = fgColor
    }

    return $(`<span style='background-color: ${bgColor};'>${aState.text}</span>`);
  }

  _formatResultState(aState) {
    const option = $(aState.element),
          color = this._getBgColor(option)

    if (! color) {
      return aState.text
    }

    return $(`<span style='background-color: ${color}; width: 32px; height: 32px;'></span><span>${aState.text}</span>`);
  }

  _getBgColor(aOption) {
    return aOption.data('bg-color') || aOption.data('color')
  }

  _getFgColor(aOption) {
    return aOption.data('fg-color')
  }
}
